import React, { type FC, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { openTrialOnboardingBenefitsModal } from 'reactApp/ui/TrialOnboardingBenefitsModal/TrialOnboardingBenefitsModal.helpers';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './DataListItemTrialOnboard.css';

const TRIAL_ONBOARDING_DATALIST_IMG_URL = `${cdnPackagesUrl}/static/cloud/promo/trialOnboarding/trialOnboardingDatalistItem.png`;

export const DataListItemTrialOnboard: FC = () => {
    const storage = useSelector(getCurrentStorage);

    useEffect(() => {
        sendDwh({
            eventCategory: 'trial-onboard-datalist-item',
            action: 'show',
            dwhData: {
                source: storage,
            },
        });
    }, []);

    const onClickHandler = useCallback(() => {
        sendDwh({
            eventCategory: 'trial-onboard-datalist-item',
            action: 'click',
            dwhData: {
                source: storage,
            },
        });
        openTrialOnboardingBenefitsModal();
    }, [storage]);

    return (
        <div className={styles.root} onClick={onClickHandler}>
            <img src={TRIAL_ONBOARDING_DATALIST_IMG_URL} alt="Что в подписке?" className={styles.image} />
        </div>
    );
};
